export const emitNotificationEvent = (data: any) => {
  dispatchEvent(
    new CustomEvent('@germinare/navbar/notification/change', {
      detail: {
        id: data?.id,
        type: data?.type,
        children: data?.children,
        title: data?.title,
        message: data?.message,
        isIndeterminate: data?.isIndeterminate,
        textButton: data?.textButton,
        customButton: data?.customButton,
        onClick: data?.onClick,
        onClose: data?.onClose,
      },
    })
  )
}

export const listenNotificationEvent = (cb: (event: any) => void) => {
  window.addEventListener('@germinare/navbar/notification/change', cb)
}
